// extracted by mini-css-extract-plugin
export default {"spinner-container":"Loading_spinner-container__npJhx","spinner":"Loading_spinner__Y9jaO","spin":"Loading_spin__grgdF","text":"Loading_text__heC-P"};